import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { PercentageIcon } from '@/icons';
import { createFileRoute, Outlet, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const categorySearchSchema = z.object({
  // nuqs writes spaces as '+', which TanStack Router doesn't decode back to spaces
  categoryName: z
    .string()
    .transform((value) => value.replace(/\+/g, ' '))
    .optional(),
});

export const Route = createFileRoute('/(app)/configuration-management/commissions/$categoryId')({
  validateSearch: (search: SearchSchemaInput) => categorySearchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    categoryName: search.categoryName,
  }),
  loader: ({ deps: { categoryName } }) => {
    return {
      title: (
        <>
          <Translation id="configurationManagement.charges.crumb.categorySlab.title" />
          {': '}
          <span className="text-destructive-text">{categoryName}</span>
        </>
      ),
      crumb: <CrumbTitle id="configurationManagement.charges.crumb.categorySlab.title" icon={PercentageIcon} />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
